import { toast } from 'react-toastify';
import { encrypted } from './Utility';

/**
 * Handles a 401 Unauthorized response
 */
export const handleUnauthorized = (navigate = null, redirectPath = "/sign-in", delayMs = 1500, message = "Session expired. Please login again.") => {
    const isLocalEnv = window.location.host.includes('localhost');
    
    if (isLocalEnv) {
        toast.error("Unauthorized: Please check your authentication token");
        return;
    }

    toast.error(message);
    localStorage.clear();

    if (navigate && typeof navigate === 'function') {
        setTimeout(() => navigate(redirectPath), delayMs);
    } else {
        setTimeout(() => {
            window.location.href = redirectPath;
        }, delayMs);
    }
};

/**
 * Safely cancels an axios CancelToken source
 */
export const cancelCancelToken = (cancelTokenSource, reason = "Request cancelled", errorContext = "request") => {
    if (!cancelTokenSource) return false;

    try {
        cancelTokenSource.cancel(reason);
        return true;
    } catch (err) {
        console.warn(`Error cancelling ${errorContext}:`, err);
        return false;
    }
};

const decryptErrorResponse = (encryptedBody) => {
    if (!encryptedBody) return null;

    try {
        return JSON.parse(encrypted.decrypt(encryptedBody));
    } catch {
        return null;
    }
};

/**
 * Global function to handle API errors
 */
export const handleApiError = (error, toastInstance = null, defaultMessage = "An error occurred. Please try again.") => {
    const encryptedBody = error?.response?.data?.encryptedBody;
    const errorItem = decryptErrorResponse(encryptedBody);

    const errorMessage = errorItem?.detail
        || errorItem?.message
        || error?.response?.data?.message
        || error?.message
        || defaultMessage;

    if (toastInstance && typeof toastInstance.error === 'function') {
        toastInstance.error(errorMessage);
    }

    return errorMessage;
};

export const handleAuthError = (error, toastInstance = null, defaultMessage = "Authentication failed. Please try again.") => {
    return handleApiError(error, toastInstance, defaultMessage);
};
